import { useEffect, useState } from "react";
import { getLeadSyncSettingsApi, updateLeadSyncSettingsApi, } from "../apiServices/leadSyncServices";

const useLeadSync = () => {

  const [settings, setSettings] = useState(null);

  const [loading, setLoading] = useState(false);

  const fetchSettings = async () => {

    try {

      setLoading(true);

      const res = await getLeadSyncSettingsApi();

      setSettings(res.data);

    } catch (err) {

      console.error(err);

    } finally {

      setLoading(false);
    }
  };

  const updateSettings = async (payload) => {

    const res = await updateLeadSyncSettingsApi(
      payload
    );

    setSettings(res.data);

    return res;
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return { settings, loading, fetchSettings, updateSettings, };
};

export default useLeadSync;